document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('[data-mj-optout-form]');
  const checkbox = document.querySelector('[data-mj-optout-checkbox]');
  const email = document.querySelector('[data-mj-optout-email]');
  const submit = document.querySelector('[data-mj-optout-submit]');
  const status = document.querySelector('[data-mj-optout-status]');

  if (!form || !checkbox || !email || !submit || !status) return;

  const updateState = () => {
    const enabled = checkbox.checked;
    email.disabled = !enabled;
    submit.disabled = !enabled;
    if (!enabled) email.value = '';
  };

  checkbox.addEventListener('change', updateState);

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!checkbox.checked || !email.validity.valid) {
      email.focus();
      return;
    }

    submit.disabled = true;
    status.textContent = 'Submitting your opt-out request…';

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      });

      if (!response.ok) throw new Error('Request failed');
      status.textContent = 'Thank you. Your opt-out request has been submitted for processing.';
      form.reset();
      updateState();
    } catch (error) {
      status.textContent = 'We could not submit your request right now. Please try again.';
      submit.disabled = false;
    }
  });

  updateState();
});
